import { render, staticRenderFns } from "./app-nav-bar-vertical.vue?vue&type=template&id=0449528e&scoped=true&"
import script from "./app-nav-bar-vertical.vue?vue&type=script&lang=js&"
export * from "./app-nav-bar-vertical.vue?vue&type=script&lang=js&"
import style0 from "./app-nav-bar-vertical.vue?vue&type=style&index=0&id=0449528e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0449528e",
  null
  
)

export default component.exports